import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Search from '@mui/icons-material/Search';
import {
    gridColumnVisibilityModelSelector,
    useGridApiContext, useGridRootProps, useGridSelector,
} from '@mui/x-data-grid';
import _ from 'lodash';

import TooltipInfo from '../common/TooltipInfo';

export function CustomColumnsPanel() {
    const apiRef = useGridApiContext();
    const rootProps = useGridRootProps();
    const columnVisibilityModel = useGridSelector(
        apiRef,
        gridColumnVisibilityModelSelector,
    );
    const [columns, setColumns] = useState(rootProps.columns);

    const toggleAbleColumns = _.uniqBy(columns, (column) => column.title);
    const [visibleColumns, setVisibleColumns] = useState(columnVisibilityModel);

    const toggleColumn = (child, checked) => {
        const visibilitySetColumns = columns.filter(
            (column) => column.title === child.title
        );

        const visibilityChanges = {};
        visibilitySetColumns.forEach((column) => {
            visibilityChanges[column.field] = checked;
        });

        setVisibleColumns({
            ...visibleColumns,
            ...visibilityChanges,
        });
    };
    const updateModel = () => {
        apiRef.current.setColumnVisibilityModel(visibleColumns);
        apiRef.current.hidePreferences();
    };
    const setAllColumnVisibility = (checked) => {
        const visibilityChanges = {};
        columns.forEach((column) => { visibilityChanges[column.field] = checked; });
        setVisibleColumns({
            ...visibleColumns,
            ...visibilityChanges,
        });
    };

    const filterColumns = (searchTerm) => {
        const filteredColumns = rootProps.columns.filter(
            (column) => column.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setColumns(filteredColumns);
    };

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '1rem' }}>
                <TextField
                    id="search-bar"
                    variant="outlined"
                    placeholder="Search"
                    size="small"
                    onInput={(e) => {
                        filterColumns(e.target.value);
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
            <Box sx={{
                overflow: 'auto', width: '100%', padding: '1rem', borderBottom: '1px solid lightgrey',
            }}
            >
                {toggleAbleColumns.map((column) => (
                    <Stack direction="row" alignItems="center" key={column.field}>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    checked={visibleColumns[column.field] !== false}
                                    sx={{ p: 1 }}
                                />
                            )}
                            label={column.title}
                            onChange={(val, newValue) => toggleColumn(column, newValue)}
                        />
                        {
                        column.description
                        && column.description !== column.title
                        && column.description !== column.headerName
                        && (
                            <div style={{ flexGrow: 1, textAlign: 'end' }}>
                                <TooltipInfo
                                    title={column.description}
                                    placement="right"
                                    noMaxWidth
                                    enterNextDelay={100}
                                    fontSize="inherit"
                                />
                            </div>
                        )
                        }
                    </Stack>
                ))}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '.2rem' }}>
                <Checkbox
                    checked={
                        Object.values(visibleColumns).every(
                            (value) => value === true,
                        )
                    }
                    indeterminate={
                        Object.values(visibleColumns).some(
                            (value) => value === true,
                        ) && Object.values(visibleColumns).some(
                            (value) => value === false,
                        )
                    }
                    onChange={(val, newValue) => setAllColumnVisibility(newValue)}
                />
                <Button
                    onClick={
                        () => {
                            setVisibleColumns(columnVisibilityModel);
                            apiRef.current.hidePreferences();
                        }
                    }
                    disabled={_.isEqual(columnVisibilityModel, visibleColumns)}
                >
                    Cancel
                </Button>
                <Button
                    onClick={
                        () => updateModel()
                    }
                    variant="contained"
                    disabled={_.isEqual(columnVisibilityModel, visibleColumns)}
                >
                    Save Changes
                </Button>
            </Box>
        </Box>
    );
}
